"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
var $a3cb7187eafc863e$exports = {};
function $a3cb7187eafc863e$var$shiftAndMerge(board, direction) {
    const transpose = (matrix)=>matrix[0].map((_, i)=>matrix.map((row)=>row[i]));
    const reverse = (matrix)=>matrix.map((row)=>[
                ...row
            ].reverse());
    const rotate = {
        up: transpose,
        down: (b)=>reverse(transpose(b)),
        left: (b)=>b,
        right: reverse
    };
    const unrotate = {
        up: transpose,
        down: (b)=>transpose(reverse(b)),
        left: (b)=>b,
        right: reverse
    };
    const rotated = rotate[direction](board);
    let score = 0;
    const mergedBoard = rotated.map((row)=>{
        const { merged: merged, mergeScore: mergeScore } = $a3cb7187eafc863e$var$mergeRow(row);
        score += mergeScore;
        return merged;
    });
    return {
        board: unrotate[direction](mergedBoard),
        totalScore: score
    };
}
function $a3cb7187eafc863e$var$mergeRow(row) {
    const filtered = row.filter((num)=>num !== 0);
    const result = [];
    let score = 0;
    for(let i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
        const merged = filtered[i] * 2;
        result.push(merged);
        score += merged;
        i++;
    } else result.push(filtered[i]);
    while(result.length < 4)result.push(0);
    return {
        merged: result,
        mergeScore: score
    };
}
$a3cb7187eafc863e$exports = {
    shiftAndMerge: $a3cb7187eafc863e$var$shiftAndMerge
};


var $a5fd07fa01589658$require$shiftAndMerge = $a3cb7187eafc863e$exports.shiftAndMerge;
class $a5fd07fa01589658$var$Game {
    constructor(initialState = null){
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.hasWon = false;
        this.board = this.isValidBoard(initialState) ? initialState.map((row)=>[
                ...row
            ]) : this.createEmptyBoard();
        // Initial status check
        this.updateStatus();
    }
    createEmptyBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    isValidBoard(board) {
        return Array.isArray(board) && board.length === this.size && board.every((row)=>Array.isArray(row) && row.length === this.size && row.every((cell)=>Number.isInteger(cell) && cell >= 0));
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board.map((row)=>[
                ...row
            ]);
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.board = this.createEmptyBoard();
        this.score = 0;
        this.status = "playing";
        this.hasWon = false;
        this.spawnTile();
        this.spawnTile();
    }
    restart() {
        this.start();
    }
    handleMove(direction) {
        if (this.status !== "playing") return;
        const prevBoard = this.board;
        const { board: newBoard, totalScore: totalScore } = $a5fd07fa01589658$require$shiftAndMerge(prevBoard, direction);
        if (!this.boardsEqual(prevBoard, newBoard)) {
            this.board = newBoard;
            this.score += totalScore;
            // Check for win before spawning a tile
            if (!this.hasWon && this.board.flat().some((val)=>val >= 2048)) {
                this.hasWon = true;
                this.status = "win";
                return;
            }
            this.spawnTile();
            this.updateStatus();
        }
    }
    moveLeft() {
        this.handleMove("left");
    }
    moveRight() {
        this.handleMove("right");
    }
    moveUp() {
        this.handleMove("up");
    }
    moveDown() {
        this.handleMove("down");
    }
    canMove() {
        return [
            "up",
            "down",
            "left",
            "right"
        ].some((dir)=>{
            const { board: moved } = $a5fd07fa01589658$require$shiftAndMerge(this.board, dir);
            return !this.boardsEqual(this.board, moved);
        });
    }
    spawnTile() {
        if (this.status !== "playing") return;
        const emptyCells = [];
        for(let r = 0; r < this.size; r++){
            for(let c = 0; c < this.size; c++)if (this.board[r][c] === 0) emptyCells.push([
                r,
                c
            ]);
        }
        if (emptyCells.length === 0) return;
        const [row, col] = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
    }
    boardsEqual(b1, b2) {
        return b1.every((row, r)=>row.every((val, c)=>val === b2[r][c]));
    }
    updateStatus() {
        if (this.hasWon) this.status = "win";
        else if (!this.canMove()) this.status = "lose";
        else if (this.status === "idle") this.status = "playing";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


document.addEventListener("DOMContentLoaded", ()=>{
    const game = new $a5fd07fa01589658$exports();
    const scoreEl = document.querySelector(".game-score");
    const startBtn = document.querySelector(".button.start");
    const startMessageEl = document.querySelector(".message-start");
    const winMessageEl = document.querySelector(".message-win");
    const loseMessageEl = document.querySelector(".message-lose");
    // Assign unique IDs to grid cells
    document.querySelectorAll(".field-row").forEach((row, rowIndex)=>{
        row.querySelectorAll(".field-cell").forEach((cell, colIndex)=>{
            cell.id = `cell-${rowIndex}-${colIndex}`;
        });
    });
    let hasStarted = false;
    const updateBoard = ()=>{
        const board = game.getState();
        for(let r = 0; r < board.length; r++)for(let c = 0; c < board[r].length; c++){
            const cell = document.getElementById(`cell-${r}-${c}`);
            const val = board[r][c];
            const newClass = `field-cell ${val === 0 ? "empty" : `field-cell--${val}`}`;
            if (cell && (cell.className !== newClass || cell.textContent !== String(val || ""))) {
                cell.className = newClass;
                cell.textContent = val || "";
            }
        }
    };
    const updateScore = ()=>{
        scoreEl.textContent = game.getScore().toString();
    };
    const resetMessages = ()=>{
        startMessageEl.classList.add("hidden");
        winMessageEl.classList.add("hidden");
        loseMessageEl.classList.add("hidden");
    };
    const updateStartButton = ()=>{
        startBtn.textContent = "Restart";
        startBtn.classList.remove("start");
        startBtn.classList.add("restart");
    };
    const checkEndGame = (gameStatus)=>{
        if (gameStatus === "win") winMessageEl.classList.remove("hidden");
        else if (gameStatus === "lose") loseMessageEl.classList.remove("hidden");
    };
    const processMove = (direction)=>{
        if (!hasStarted) return;
        const gameStatus = game.getStatus();
        if (gameStatus === "playing") {
            game.handleMove(direction);
            updateBoard();
            updateScore();
            checkEndGame(game.getStatus());
        }
    };
    const keyToDirection = {
        ArrowLeft: "left",
        ArrowRight: "right",
        ArrowUp: "up",
        ArrowDown: "down"
    };
    document.addEventListener("keydown", (e)=>{
        const direction = keyToDirection[e.code];
        if (direction) {
            e.preventDefault();
            processMove(direction);
        }
    });
    startBtn.addEventListener("click", ()=>{
        resetMessages();
        if (!hasStarted) {
            game.start();
            hasStarted = true;
            updateStartButton();
        } else {
            game.restart();
            resetMessages();
        }
        updateBoard();
        updateScore();
    });
    updateBoard();
    updateScore();
});


//# sourceMappingURL=index.fe7d5557.js.map
